export const AUTH_REFRESH_EVENT = 'AUTH_REFRESH_EVENT';
export const AUTH_INSTALL_EVENT = 'AUTH_INSTALL_EVENT';